import React from 'react'

import './Discription.css'

const Description = () => {
  return (
    <div className='discription-box'>
      <div className="discription-navigator">
        <div className="discription-nav-box">Description</div>
        <div className="discription-nav-box fade">Review (899)</div>
        </div>
        <div className="discription-discription">
          <p> I it good and trusted product. It has good popularity around the world and it is most selling product. there are some peaces of this product is in stock and the stock is about to end so please order emmidiatly. for more information you can contact with our customere care. we have policy that use first and then trust. by my self i am using this product for many days and it is very useful for me.</p>
          <p> I it good and trusted product. It has good popularity around the world and it is most selling product. there are some peaces of this product is in stock and the stock is about to end so please order emmidiatly. for more information you can contact with our customere care. we have policy that use first and then trust.</p>
        </div>
      </div>
  )
}

export default Description
